"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
//Estilo do componente PPTextField
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        label: {
            fontFamily: "Inter",
            fontSize: 12,
            height: 18
        },
        sugestions: {
            backgroundColor: 'white',
            padding: '10px',
            zIndex: 300,
            position: "absolute",
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid #ccc',
            borderRadius: '4px',
            maxWidth: '100%',
            minWidth: '200px',
            maxHeight: '200px',
            overflowY: 'scroll',
            boxShadow: '4px 4px 18px rgba(0, 0, 0, 0.25);',
            "& .loading": {
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                padding: '5px',
                fontSize: '12px',
            },
            "& .sugestion": {
                padding: '5px',
                cursor: 'pointer',
                fontSize: '14px',
                color: '#2B304F',
                fontWeight: '400',
                borderRadius: '4px',
                "&.disabled": {
                    cursor: 'not-allowed',
                    color: '#8B90A3'
                },
                "&:hover": {
                    backgroundColor: '#E2E6F3',
                    color: '#20203F',
                }
            }
        },
        tooltip: {
            display: 'flex',
            alignItems: 'flex-end',
            height: '100%',
        },
        item: {
            position: 'relative',
            "& .pp-tooltip": {
                width: '100%',
            },
        },
        help: {
            fontSize: 13,
            color: 'grey',
            fontFamily: "Inter"
        },
        root: {
            marginTop: 3,
            backgroundColor: 'white',
            width: '100%',
            fontFamily: "Inter",
            fontSize: 14,
            height: 40,
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #141B4D",
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #898DA6",
                    borderRadius: 4,
                },
            }
        },
        _disabled: {
            marginTop: 3,
            backgroundColor: '#EBEBEB',
            fontSize: 14,
            height: 40,
            fontFamily: "Inter",
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                    borderRadius: 4,
                },
            }
        },
        _required_error: {
            marginTop: 3,
            backgroundColor: 'white',
            fontSize: 14,
            height: 40,
            fontFamily: "Inter",
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "2px solid #D35555",
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "2px solid #D35555",
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "2px solid #D35555",
                    borderRadius: 4,
                },
            },
        },
        _required: {
            marginTop: 3,
            backgroundColor: 'white',
            fontSize: 14,
            height: 40,
            fontFamily: "Inter",
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    borderLeftWidth: 3,
                    borderBottom: '1px solid #141B4D',
                    borderTop: '1px solid #141B4D',
                    borderRight: '1px solid #141B4D',
                    borderLeftColor: '#FFB800',
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderLeftWidth: 3,
                borderBottom: 0,
                borderTop: 0,
                borderRight: 0,
                borderLeftColor: '#FFB800',
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    borderLeftWidth: 3,
                    borderBottom: '1px solid #898DA6',
                    borderTop: '1px solid #898DA6',
                    borderRight: '1px solid #898DA6',
                    borderLeftColor: '#FFB800',
                    borderRadius: 4,
                },
            }
        },
        _readOnly: {
            marginTop: 3,
            fontSize: 14,
            fontFamily: "Inter",
            height: 40,
            backgroundColor: '#EBEBEB',
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #141B4D",
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #898DA6",
                    borderRadius: 4,
                },
            }
        },
        //Para campos multilinha: 
        multiline: {
            marginTop: 3,
            backgroundColor: 'white',
            width: '100%',
            fontFamily: "Inter",
            fontSize: 14,
            minHeight: 40,
            border: 0,
            padding: '9px 14px',
            resize: 'vertical',
            "&::placeholder": {
                color: '#2B304F80 ',
                fontStyle: 'normal'
            },
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #141B4D",
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #898DA6",
                    borderRadius: 4,
                },
            }
        },
        multiline_disabled: {
            marginTop: 3,
            backgroundColor: '#EBEBEB',
            fontSize: 14,
            minHeight: 40,
            fontFamily: "Inter",
            width: "100% !important",
            border: 0,
            padding: '9px 14px',
            resize: 'vertical',
            "&::placeholder": {
                color: '#2B304F80 ',
                fontStyle: 'normal'
            },
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                    borderRadius: 4,
                },
            }
        },
        multiline_required_error: {
            marginTop: 3,
            backgroundColor: 'white',
            fontSize: 14,
            fontFamily: "Inter",
            width: '100%',
            border: "2px solid #D35555",
            borderRadius: 4,
            padding: '7px 15px',
            resize: 'vertical',
            "&::placeholder": {
                color: '#2B304F80 ',
                fontStyle: 'normal'
            },
        },
        multiline_required: {
            marginTop: 3,
            backgroundColor: 'white',
            fontSize: 14,
            fontFamily: "Inter",
            width: "100%",
            border: 0,
            borderLeft: '3px solid #FFB800',
            borderRadius: 4,
            padding: '10px 14px',
            resize: 'vertical',
            "&::placeholder": {
                color: '#2B304F80 ',
                fontStyle: 'normal'
            },
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    borderLeftWidth: 3,
                    borderBottom: '1px solid #141B4D',
                    borderTop: '1px solid #141B4D',
                    borderRight: '1px solid #141B4D',
                    borderLeftColor: '#FFB800',
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderLeftWidth: 3,
                borderBottom: 0,
                borderTop: 0,
                borderRight: 0,
                borderLeftColor: '#FFB800',
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    borderLeftWidth: 3,
                    borderBottom: '1px solid #898DA6',
                    borderTop: '1px solid #898DA6',
                    borderRight: '1px solid #898DA6',
                    borderLeftColor: '#FFB800',
                    borderRadius: 4,
                },
            }
        },
        multiline_readOnly: {
            cursor: 'default',
            marginTop: 3,
            fontSize: 14,
            fontFamily: "Inter",
            minHeight: 40,
            border: 0,
            padding: '9px 14px',
            width: "100%",
            backgroundColor: '#EBEBEB',
            resize: 'vertical',
            "&::placeholder": {
                color: '#2B304F80 ',
                fontStyle: 'normal'
            },
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #141B4D",
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #898DA6",
                    borderRadius: 4,
                },
            }
        },
    });
});
